import { render, staticRenderFns } from "./ProductFlowPrice.vue?vue&type=template&id=1bb0e008"
import script from "./ProductFlowPrice.vue?vue&type=script&lang=js"
export * from "./ProductFlowPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports